/* EZ Rides — live open/closed status, computed in the browser using Ontario
   time so it's correct for every visitor regardless of their own timezone.
   Reads data-hours-0..data-hours-6 (0=Sun..6=Sat) in 24h "10:00-20:00" or
   "Closed" format from any [data-store] or [data-store-page] element. */
(function () {
  var tz = 'America/Toronto';

  function nowParts() {
    var f = new Intl.DateTimeFormat('en-CA', { timeZone: tz, weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false });
    var p = {};
    f.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    var days = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return { day: days[p.weekday], mins: (parseInt(p.hour, 10) % 24) * 60 + parseInt(p.minute, 10) };
  }

  function parseRange(str) {
    if (!str) return null;
    var m = str.trim().match(/^(\d{1,2}):?(\d{2})?\s*-\s*(\d{1,2}):?(\d{2})?$/);
    if (!m) return null;
    return { o: (+m[1]) * 60 + (+m[2] || 0), c: (+m[3]) * 60 + (+m[4] || 0) };
  }

  function fmt(mins) {
    var h = Math.floor(mins / 60), mm = mins % 60, ap = h >= 12 ? 'pm' : 'am';
    h = h % 12 || 12;
    return h + (mm ? ':' + (mm < 10 ? '0' : '') + mm : '') + ap;
  }

  function applyStatus(el, t) {
    var today = el.getAttribute('data-hours-' + t.day) || '';
    var h = parseRange(today);
    var dot = el.querySelector('[data-dot]');
    var txt = el.querySelector('[data-status-text]');

    if (!h) {
      if (today) {
        if (txt) txt.textContent = today;
        if (/closed/i.test(today)) el.classList.add('is-closed');
      }
      return;
    }

    if (t.mins >= h.o && t.mins < h.c) {
      el.classList.add('is-open');
      if (txt) txt.textContent = 'Open now · closes ' + fmt(h.c);
    } else {
      el.classList.add('is-closed');
      var next = null;
      for (var i = 0; i < 7; i++) {
        var d = (t.day + i) % 7;
        var hh = parseRange(el.getAttribute('data-hours-' + d) || '');
        if (hh && (i > 0 || t.mins < hh.o)) { next = { i: i, hh: hh }; break; }
      }
      var names = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      if (txt) {
        txt.textContent = next
          ? ('Closed · opens ' + (next.i === 0 ? 'today' : next.i === 1 ? 'tomorrow' : names[(t.day + next.i) % 7]) + ' ' + fmt(next.hh.o))
          : 'Closed';
      }
    }
  }

  function prettifyHoursTable(root) {
    var t = nowParts();
    root.querySelectorAll('[data-day]').forEach(function (row) {
      var cell = row.querySelector('[data-hours-cell]');
      if (!cell) return;
      var h = parseRange(cell.textContent);
      if (h) cell.textContent = fmt(h.o) + ' – ' + fmt(h.c);
      if (+row.getAttribute('data-day') === t.day) row.classList.add('is-today');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var t = nowParts();
    document.querySelectorAll('[data-store], [data-store-page]').forEach(function (el) {
      applyStatus(el, t);
    });
    document.querySelectorAll('[data-hours-table]').forEach(function (el) {
      prettifyHoursTable(el);
    });
  });
})();
